import React from 'react';

interface LogoProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  src, 
  alt, 
  width = 230, 
  height, 
  className = '' 
}) => {
  return (
    <img 
      src={src} 
      alt={alt} 
      width={width} 
      height={height} 
      className={className}
      style={{ maxWidth: '100%' }}
    />
  );
};

export default Logo; 